/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const { Dragster } = require('exports-loader?type=commonjs&exports=Dragster!dragster');
require('custom-event-polyfill');

const deps = [];

module.exports = angular
  .module('bench.ui.dragAndDropDisplay', deps)

  .directive('blDragAndDropDisplay', () => ({
    restrict: 'A',
    scope: {},
    bindToController: true,
    controller() {},
    link(scope, elem, attrs) {
      const dragster = new Dragster(document.body);

      document.addEventListener('dragster:enter', e => elem.addClass('bl-dragover'), false);

      document.addEventListener('dragster:leave', e => elem.removeClass('bl-dragover'), false);

      return document.body.addEventListener('drop', e => dragster.dragleave(e), false);
    },

    controllerAs: 'vm',
  }));
